<template>
    <div class="customer_list">
        <div class="sales_header">
            <div class="chouse_wrap">
                <ul class="task_list_list">
                    <li class="task_list_item bianhao">
                        <el-input placeholder="客源编号" v-model="searchInfo.customerId" @input="handleCurrentChange(1)" clearable></el-input>
                    </li>
                    <li class="task_list_item zhuangtai">
                        <div class="txt" style="min-width: 60px;">客源类型：</div>
                        <el-select v-model="searchInfo.transactionType" placeholder="不限" @change="handleCurrentChange(1)" @visible-change="getCustomerType" clearable>
                            <el-option v-for="(item,index) in customerTypeList" :key="index" :label="item.valueDesc" :value="item.value"></el-option>
                        </el-select>
                    </li>
<!--                    <li class="task_list_item zhuangtai">-->
<!--                        <div class="txt" style="width: 36px;">提交人：</div>-->
<!--                        <el-input placeholder="请输入" v-model="searchInfo.employeeId" @input="handleCurrentChange(1)" clearable></el-input>-->
<!--                    </li>-->
                    <li class="task_list_item zhuangtai">
                        <div class="txt" style="min-width: 36px;">录入人：</div>
                        <!--            <el-select v-model="searchInfo.employeeId" placeholder="不限" @visible-change="Getmessage" @change="handleCurrentChange(1)" clearable>-->
                        <!--              <el-option v-for="(item,index) in employeesData" :key="index" :label="item.name" :value="item.id"></el-option>-->
                        <!--            </el-select>-->
                        <el-autocomplete class="select" popper-class="my-autocomplete" v-model="searchInfo.employeeName" :fetch-suggestions="querySearchAsync" placeholder="请选择" @select="handleSelect" clearable>
                            <template slot-scope="{ item }">
                                <div class="name" @select="handleSelect">{{ item.name }}</div>
                            </template>
                        </el-autocomplete>
                        <!--            <i class="iconfont icon-icon_xiangxia"></i>-->
                    </li>
                    <li class="task_list_item zhuangtai">
                        <div class="txt" style="min-width: 60px;">录入时间：</div>
                        <div class="inp_box" style="width: 240px">
                            <el-date-picker @change="handleCurrentChange(1)" value-format="yyyy-MM-dd" v-model="searchInfo.date" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" clearable>
                            </el-date-picker>
                        </div>
                    </li>
                    <li class="task_list_item zhuangtai">
                        <div class="txt" style="min-width: 36px;">审批状态：</div>
                        <el-select v-model="searchInfo.applyStatus" placeholder="不限" @change="handleCurrentChange(1)" clearable>
                            <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </li>
                </ul>
            </div>
            <!-- <div class="sales_header_rigth">

              <el-button type="primary" @click="addHouse" v-if="permisShow('客源新增')">

                添加客源
              </el-button>
            </div> -->
        </div>
        <div class="sales_list_wrap">
            <el-table border :data="customerData" style="width: 100%;" :header-cell-style="setHeaderStyle" :row-class-name="tableRowClassName" @row-dblclick="gocustomerDetails" ref="multipleTable" highlight-current-row @row-click="rowColorclick">

                <el-table-column label="编号" width="120">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.cusCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客源类型" >
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.transactionType}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="姓名" >
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.customerName}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="性质">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.pubAndPriv}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="客源等级" >
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.customerLevel}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="审批状态">
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.applyStatus}}</span>
                    </template>
                </el-table-column>

                <el-table-column label="录入人" >
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.employeeName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="entrustDate" label="录入时间" >
                    <template slot-scope="scope">
                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.inputTime}}</span>
                    </template>
                </el-table-column>
<!--                <el-table-column label="审批意见">-->
<!--                    <template slot-scope="scope">-->
<!--                        <span :class="{rowColor:scope.row.customerId===isRowColor}" :style="{'color':scope.row.color?scope.row.color:''}">{{scope.row.applyOpinion}}</span>-->
<!--                    </template>-->
<!--                </el-table-column>-->
            </el-table>
        </div>
        <div class="foot-out">
            <div class="foot-out-left">
                <!--客源统计-->
                <!-- <div class="tongji cusp" @click="Tostatistics">
                  <i class="iconfont icon-icon_tongji"></i>客源统计
                </div> -->
                <!--导出-->
                <!-- <div class="daochu cusp" @click="toDao" v-if="permisShow('客源导出')">
                  <i class="iconfont icon-icon_daochu"></i>导出
                </div> -->
                <!--收藏-->
                <!-- <div class="shoucang cusp" @click="getCollect">
                  <i class="iconfont icon_shoucang"></i>我的收藏
                </div> -->
            </div>
            <div class="foot-out-right">
                <div class="footer_page">
                    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="20" layout="total, prev, pager, next, sizes, jumper" :total="total"></el-pagination>
                </div>
            </div>
        </div>

    </div>
</template>
<script type="text/javascript">
    import {
        findCustomer,
        BuyPayWay,
        RentPayWay,
        customerLevel,
        Collect,
        deleteCollect,
        queryApplyCustomer
    } from "@/api/customeManage";
    import { storeFind, employeeQuery, departmentFind } from "../../api/manageCenter";
    import { dicGet, easypoi } from "../../api/index";
    import { getRouterLevel } from "@/vue/util/tool";
    export default {
        // name: "客源管理",
        name: "/waitCustomer",
        data() {
            let permisList = JSON.parse(sessionStorage.getItem('permisList'));
            let levelList = JSON.parse(sessionStorage.getItem('levelList'));
            return {
                isRowColor: "",
                permisList,
                levelList,
                total: 0,
                customerTypeList: [],//客源类型
                customerData: [],
                employeesData:{},
                searchInfo: {
                    date:'',//提交日期
                    applyStatus:'',//审批状态
                    permissionLevel:getRouterLevel("待审批客源查看"),//权限
                    transactionType:'',//类型
                    customerId:'',//客源编号
                    employeeId:'',//提交人
                    employeeName:'',
                },
                currentPage: 1,
                pageNumber: 1,
                pageSize: 20,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "当天",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                // start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "本季度",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                statusList: [
                    {
                        label: "待提交",
                        value: "WAITING_FOR_APPROVAL"
                    },
                    // {
                    //     label: "待审批",
                    //     value: "AUDITED"
                    // },
                    {
                        label: "审批中",
                        value: "TO_BE_AUDITED"
                    },
                    {
                        label: "审批拒绝",
                        value: "UNABLE"
                    }
                ], //状态列表
            };
        },
        methods: {
            //修改当前行字体颜色
            rowColorclick(row) {
                this.isRowColor = row.customerId;
            },
            // permisShow(data) {
            //   // 权限配置
            //   let result = this.permisList.indexOf(data);
            //   if (result >= 0) {
            //     return true
            //   } else {
            //     return false
            //   }
            // },

            //表单头部颜色
            setHeaderStyle() {
                return "background-color: #F2F4FF";
            },
            //分页
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.findCustomer();
                //  //cosole.log(this.$store.state.customerType)
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNumber = 1;
                this.currentPage = 1;
                this.findCustomer();

            },
            //查询客源
            findCustomer(obj) {
                this.isRowColor = "";
                var params = Object.assign({ "page.pageNumber": this.pageNumber * this.pageSize - this.pageSize, "page.pageSize": this.pageSize,},this.searchInfo);
                this.$post(queryApplyCustomer, params).then(res => {
                    if (res.success === true) {
                        this.customerData = res.data;
                        this.total = res.total;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg
                        });
                    }
                });

            },
            //查询客源类型
            getCustomerType() {
                let params = {
                    code: "customerType"
                };
                this.$post(dicGet, params).then(res => {
                    if (res.success) {
                        this.customerTypeList = res.data;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error"
                        });
                    }
                })
            },

            //客源详情
            tableRowClassName({ row, rowIndex }) {
                //把每一行的索引放进row
                row.index = rowIndex;
            },
            gocustomerDetails(row) {
                var index = row.index;
                this.$router.push({ path: "/purchaseDetail" });
                localStorage.setItem("customerId", this.customerData[index].customerId);
                sessionStorage.setItem("employeeId", this.customerData[index].employeeId);
            },
            querySearchAsync(queryString, cb) {
                let params = {
                    name: queryString,
                    status:'ENABLE',
                };

                this.$post(employeeQuery, params).then(res => {
                    if (res.success) {
                        this.employeesData = res.data;
                        let restaurants = this.employeesData;
                        cb(restaurants);
                        if (!this.searchInfo.employeeName) {
                            this.searchInfo.employeeId = '';
                            this.handleCurrentChange(1);
                        }

                    } else {
                    }
                });
            },
            handleSelect(item) {
                console.log(123, item);
                this.searchInfo.employeeId = item.id;
                this.searchInfo.employeeName = item.name;
                this.handleCurrentChange(1);
                //cosole.log(this.contractMsg.signer)
            },
        },
        mounted() {
            this.findCustomer();
        },
        computed: {
            changeMemberTab() {

                this.pageNumber = 1;
                this.searchInfo.sourceValue = null;
                this.searchInfo.typeValue = null;
            }
        },
        watch: {
            changeMemberTab(val) {
                this.pageNumber = 1;
                this.currentPage = 1;
                this.findCustomer();

            }
        },
        activated() {
            this.findCustomer();
        }
    };
</script>
<style lang="less">
    .customer_list {
        .rowColor {
            color: #fff !important;
        }
        .el-select {
            min-width: 60px;
        }
        .el-table .cell.el-tooltip {
            width: 260px !important;
            margin-left: 10px;
        }
        .bianhao {
            .el-input {
                width: 165px;
                .el-input__inner {
                    width: 165px;
                }
            }
        }
        .el-date-editor .el-range-input {
            background: #ffffff;
        }
        .el-range-editor.el-input__inner {
            padding: 0;
            /*border: none!important;*/
            width: 260px;
        }
    }
    .collect {
        width: 40px;
        height: 40px;
        cursor: pointer;
        i {
            color: #707070;
            &.active {
                color: red;
            }
        }
    }
    .task_list_list .el-input__prefix {
        display: none;
    }
    .customer_list .el-checkbox__inner::after {
        height: 3px;
        left: 2px;
    }
    /*.el-table--enable-row-hover .el-table__body tr:hover > td {*/
    /*  background-color: #f5f5f5 !important;*/
    /*}*/
    /*.el-checkbox__input{*/
    /*line-height: 9px;*/
    /*}*/
    .customer_list .el-input__inner {
        background: #ffffff !important;
        border: 1px solid #dbdbdb !important;
        border-radius: 4px !important;
    }

    /*.sales_list_wrap  .el-table--border td{*/
    /*  !*border-bottom: 1px solid #999999;*!*/
    /*  !*color: #000000;*!*/
    /*  }*/
    .sales_list_wrap .el-table::before {
        height: 0;
    }
    /* .el-table td, .el-table th.is-leaf{*/
    /*  border-bottom: 1px solid #999999;*/
    /*  border-right: 1px solid #999999;*/
    /*  color: #000000;*/
    /*}*/
    .sales_list_wrap .el-table--border th.is-leaf {
        padding: 5px;
        color: #000000;
    }
</style>
<style type="text/css" lang="less" >
    .customer_el_menu {
        .el-table .cell,
        .el-table th div,
        .el-table--border td:first-child .cell,
        .el-table--border th:first-child .cell {
            text-align: center;
        }

        // .el-popper .popper__arrow,
        // .el-popper .popper__arrow::after {
        //   border: none;
        // }

        // .el-popper[x-placement^=bottom] {
        //   margin-top: 0;
        // }
        .el-dropdown-menu__item {
            float: left;
            width: 33.33%;
            display: flex;
            flex-direction: column;
            line-height: 15px;
            padding: 0;
            align-items: center;
            margin-top: 28px;
            color: #5e75e6;
            font-size: 14px;
            padding-top: 10px;
            text-align: center;
        }
        .add_font {
            font-size: 30px;
        }

        .add_sales {
            margin-top: 8px;
        }
        #add_title {
            font-size: 14px;
            line-height: 14px;
            color: #999999;
            padding: 0 10px;
            margin-top: 5px;
        }
    }

    .customer_list {
        height: 100%;
        min-width: 1200px;
        position: relative;
        background: #ffffff;

        .sales_header {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .chouse_wrap {
                display: flex;
                height: 60px;
                align-items: center;
                flex-wrap: wrap;
                max-width: 1550px;
                min-width: 1290px !important;

                .task_list_list {
                    display: flex;
                    margin-right: 40px;

                    .task_list_item {
                        display: flex;
                        width: auto;
                        background: white;
                        margin-left: 10px !important;
                        position: relative;
                        .txt {
                            font-size: 12px;
                            padding: 0 !important;
                            /*display: flex;*/
                            /*justify-content: center;*/
                            /*align-items: center;*/
                            background: #ffffff !important;
                            color: #666666 !important;
                        }
                        .inp_box {
                            display: flex;
                            align-items: center;
                            width: 100px;

                            > input {
                                width: 50px;
                                text-align: center;
                                font-size: 14px;
                                height: 100%;
                                outline: none;
                            }
                        }

                        // .icon-icon_S-niandai,
                        // .icon-icon_S-mendian,
                        // .icon-icon_S-leixing-1,
                        // .icon-icon_S-laiyuan,
                        // .icon-icon_S-yuangong,
                        // .icon-icon_S-zhuangtai {
                        //   width: 30px;
                        //   height: 30px;
                        //   font-size: 20px;
                        //   background: #ccc;
                        //   border: none;
                        // }

                        .el-input__inner {
                            height: 30px;
                            border-radius: 0;
                            border: 1px solid #ccc;
                            padding-left: 10px;
                            padding-right: 10px;
                        }

                        .el-input__prefix {
                            background: #ccc;
                            width: 30px;
                            left: 0;
                        }

                        .el-input__icon {
                            line-height: 30px;
                            color: #c0c4cc !important;
                        }

                        &.mendian,
                        &.zhuangtai {
                            .icon-icon_S-niandai,
                            .icon-icon_S-mendian,
                            .icon-icon_S-leixing-1,
                            .icon-icon_S-laiyuan,
                            .icon-icon_S-yuangong,
                            .icon-icon_S-zhuangtai {
                                line-height: 30px;
                                text-align: center;
                                color: white;
                            }

                            .el-input__inner {
                                padding-left: 10px;
                            }
                        }

                        .icon-icon_xiangxia {
                            position: absolute;
                            right: 5px;
                            top: 8px;
                            color: #ccc;
                        }
                    }

                    .el-input {
                        height: 30px;

                        .el-input-group__append,
                        .el-input-group__prepend {
                            padding: 0 10px;
                            background: #5e75e6;
                            /*border: none;*/
                        }

                        .el-input__inner {
                            /*border: none;*/
                            height: 30px;
                            padding-right: 10px;
                        }

                        .icon-icon_sousuo {
                            color: white;
                        }
                    }
                }
            }

            .sales_header_rigth {
                /*margin-bottom: 20px;*/
                /*margin-right: 20px;*/
                /*display: flex;*/
                /*justify-content: flex-end;*/
                margin-top: 15px;
                margin-left: 10px;

                .el-button--primary {
                    width: 120px !important;
                    height: 30px;
                    line-height: 0;
                }

                .icon-xiajiantou {
                    margin-right: 5px;
                }

                .el-button--primary {
                    background: #5e75e6;
                    border: none;
                }

                .el-dropdown-menu {
                    width: 200px;
                    // height: 280px;
                }
            }
        }

        /*.sales_list_wrap {*/
        /*.el-checkbox__inner {*/
        /*width: 10px;*/
        /*height: 10px;*/
        /*margin-bottom: 50px;*/
        /*margin-top: 10px;*/
        /*}*/
        /*}*/

        .footer_page {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
            margin-bottom: 20px;

            .el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #5e75e6;
            }

            .el-pagination.is-background .btn-next,
            .el-pagination.is-background .btn-prev,
            .el-pagination.is-background .el-pager li {
                border: 1px solid #ccc;
                background: white;
            }

            // .el-icon-arrow-left:before {
            //   content: "上一页";
            //   padding: 0 20px;
            //   color: #cccccc;
            //   font-size: 12px;
            // }

            // .el-icon-arrow-right:before {
            //   content: "下一页";
            //   padding: 0 20px;
            //   color: #cccccc;
            //   font-size: 12px;
            // }
        }
    }
    .el-checkbox-group {
        margin: 0 20px 20px 20px;
    }
    .foot-out-left .tongji,
    .foot-out-left .daochu,
    .foot-out-left .shoucang {
        height: 30px;
        line-height: 30px;
        border-radius: 4px;
        margin-right: 10px;
        text-align: center;
        color: #ffffff;
        font-size: 14px;
    }
    .tongji {
        width: 100px;
        background: #5e75e6;
    }
    .daochu {
        width: 80px;
        background: rgb(34, 202, 133) !important;
    }
    .shoucang {
        width: 110px;
        background: rgb(255, 144, 77) !important;
    }
    .checkbox-out {
        overflow: hidden;
        margin-left: 25px;
        margin-bottom: 30px;
        margin-top: 10px;
    }
    .checkbox {
        float: left;
        margin-right: 25px;
        margin-bottom: 6px;
    }
    input[type="checkbox"] {
        width: 10px;
        height: 10px;
        background-color: #fff;
        -webkit-appearance: none;
        border: 1px solid #c9c9c9;
        border-radius: 2px;
        outline: none;
        vertical-align: middle;
        margin-top: 1px;
        margin-right: 5px;
    }
    input[type="checkbox"]:checked {
        /*background: url("../images/checkbox_icon.png")no-repeat center;*/
        background: #5e75e6;
    }
    input[type="checkbox"]:checked::before {
        display: block;
        content: "\2713";
        text-align: center;
        font-size: 6px;
        color: white;
        position: relative;
        top: -5px;
    }
    .el-dialog__footer {
        background: #f5f5f5;
        padding-top: 20px;
    }
    .cusp {
        cursor: pointer;
    }
    .foot-out {
        display: flex;
        justify-content: space-between;
    }
    .foot-out-left {
        display: flex;
        justify-content: flex-start;
        margin-top: 20px;
        margin-left: 20px;
    }
    .customer_list .iconfont {
        font-size: 24px;
        vertical-align: middle;
    }
</style>
